// extracted by mini-css-extract-plugin
module.exports = {"add":"styles_add__McDjH","error":"styles_error__vJ0N5"};